import { useState, useEffect } from 'react';
import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import Home from './pages/home';
import Serengeti from './pages/northern-circuits/serengeti';
import Ngorongoro from './pages/northern-circuits/ngorongoro';
import Mikumi from './pages/southern-circuits/mikumi';
import Nyerere from './pages/southern-circuits/nyerere';
import Ruaha from './pages/southern-circuits/ruaha';
import Tarangire from './pages/northern-circuits/tarangire';
import Manyara from './pages/northern-circuits/manyara';
import ArushaPark from './pages/northern-circuits/arusha-park';
import Zanzibar from './pages/tanzania_island/zanzibar';
import Kilimanjaro from './pages/mountains/kilimanjaro';
import Meru from './pages/mountains/meru';
import Safaris from './pages/safaris/safaris';
import Packages from './pages/packages/packages';

function useHashRoute() {
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return hash;
}

function App() {
  const hash = useHashRoute();

  let page;
  if (hash === '#serengeti') {
    page = <Serengeti />;
  } else if (hash === '#ngorongoro') {
    page = <Ngorongoro />;
  } else if (hash === '#mikumi') {
    page = <Mikumi />;
  } else if (hash === '#nyerere') {
    page = <Nyerere />;
  } else if (hash === '#ruaha') {
    page = <Ruaha />;
  } else if (hash === '#tarangire') {
    page = <Tarangire />;
  } else if (hash === '#manyara') {
    page = <Manyara />;
  } else if (hash === '#arusha-park') {
    page = <ArushaPark />;
  } else if (hash === '#zanzibar') {
    page = <Zanzibar />;
  } else if (hash === '#kilimanjaro') {
    page = <Kilimanjaro />;
  } else if (hash === '#meru') {
    page = <Meru />;
  } else if (hash === '#safaris') {
    page = <Safaris />;
  } else if (hash === '#packages') {
    page = <Packages />;
  } else {
    page = <Home />;
  }

  return (
    <div className="app">
      <Header />
      {page}
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
